<template lang="pug">
  .view-dashboard
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: 'view-dashboard',
};
</script>
